import {Component, OnInit, Input} from '@angular/core';
import {NumberingListItem} from "../shared/numbering-list-item";

@Component({
  selector: 'app-syllabus-curriculum-numbering-list',
  templateUrl: './syllabus-curriculum-numbering-list.component.html',
  styleUrls: ['./syllabus-curriculum-numbering-list.component.scss']
})
export class SyllabusCurriculumNumberingListComponent implements OnInit {

  @Input() item: NumberingListItem;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-numbering-list/syllabus-curriculum-numbering-list.component.ts